var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as integratorWebhookLogApi from "@rentiohq/shared-frontend/dist/reduxV2/integratorWebhookLog/integratorWebhookLog.api";
import { EIntegratorIds } from "@rentiohq/shared-frontend/dist/types/broker.types";
import { EIntegratorWebhookLogOutcome, EIntegratorWebhookLogSortBy, EIntegratorWebhookType, } from "@rentiohq/shared-frontend/dist/types/integratorWebhookLog.types";
import { showAlert } from "@rentiohq/shared-frontend/dist/utils/alert/alert.utils";
import { confirm } from "@rentiohq/shared-frontend/dist/utils/confirm.utils";
import { formatDateAndTime } from "@rentiohq/shared-frontend/dist/utils/date.utils";
import { getMessageForError } from "@rentiohq/shared-frontend/dist/utils/error.utils";
import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import React from "react";
import { useMultiselect } from "../../hooks/useMultiselect";
import { Banner } from "../Banner";
import { Button } from "../Button";
import { DataTable, } from "../DataTable";
import { EmptyState } from "../EmptyState";
import { Lozenge } from "../Lozenge";
import { Pagination } from "../Pagination";
import { SegmentedControl } from "../SegmentedControl";
import { Select } from "../Select";
import { Stack } from "../Stack";
import { TextField } from "../TextField";
import { TextStyle } from "../TextStyle";
import { IntegratorWebhookLogDetailModal } from "./IntegratorWebhookLogDetailModal";
import * as S from "./IntegratorWebhookLogs.styled";
import { countResultsByStatus, DEFAULT_SORT, getDayEndIso, getDayStartIso, getOutcomeAppearance, getResendReasonLabelKey, getResendStatusAppearance, getSortAfterHeaderClick, getWebhookTypeLabel, MAX_RESEND_COUNT, PAGE_SIZE, } from "./IntegratorWebhookLogs.utils";
var EMPTY_VALUE = "—";
var ALL = "all";
var parseId = function (value) {
    var parsed = Number(value);
    return value !== "" && Number.isInteger(parsed) && parsed > 0
        ? parsed
        : undefined;
};
var getReasonLabel = function (reason) {
    var key = getResendReasonLabelKey(reason);
    return key ? getLocalizedText(key) : reason !== null && reason !== void 0 ? reason : undefined;
};
export var IntegratorWebhookLogs = function (props) {
    var brokerId = props.brokerId;
    var isOfficeScoped = brokerId !== undefined;
    // Filters
    var _a = React.useState(1), page = _a[0], setPage = _a[1];
    // Failed first: the screen is opened to find calls that did not get through.
    var _b = React.useState(EIntegratorWebhookLogOutcome.Failed), outcome = _b[0], setOutcome = _b[1];
    var _c = React.useState(ALL), webhookType = _c[0], setWebhookType = _c[1];
    var _d = React.useState(""), brokerIdInput = _d[0], setBrokerIdInput = _d[1];
    var _e = React.useState(ALL), integratorId = _e[0], setIntegratorId = _e[1];
    var _f = React.useState(""), createdAtFrom = _f[0], setCreatedAtFrom = _f[1];
    var _g = React.useState(""), createdAtTo = _g[0], setCreatedAtTo = _g[1];
    var _h = React.useState(DEFAULT_SORT), sort = _h[0], setSort = _h[1];
    // Data
    var _j = React.useState([]), logs = _j[0], setLogs = _j[1];
    var _k = React.useState(0), totalPages = _k[0], setTotalPages = _k[1];
    var _l = React.useState(false), isFetching = _l[0], setIsFetching = _l[1];
    var _m = React.useState(), fetchError = _m[0], setFetchError = _m[1];
    var _o = React.useState(0), reloadCount = _o[0], setReloadCount = _o[1];
    // Resend
    var _p = useMultiselect([], MAX_RESEND_COUNT), selectedIds = _p.selectedIds, onSelectId = _p.onSelectId, onDeselectId = _p.onDeselectId, onSelectIds = _p.onSelectIds, onDeselectIds = _p.onDeselectIds;
    var _q = React.useState(false), isResending = _q[0], setIsResending = _q[1];
    var _r = React.useState({}), resendResults = _r[0], setResendResults = _r[1];
    var _s = React.useState(), detailLogId = _s[0], setDetailLogId = _s[1];
    var query = React.useMemo(function () { return ({
        page: page,
        limit: PAGE_SIZE,
        outcome: outcome === ALL ? undefined : outcome,
        webhookType: webhookType === ALL ? undefined : webhookType,
        brokerId: isOfficeScoped ? brokerId : parseId(brokerIdInput),
        integratorId: integratorId === ALL ? undefined : Number(integratorId),
        createdAtFrom: getDayStartIso(createdAtFrom || undefined),
        createdAtTo: getDayEndIso(createdAtTo || undefined),
        sortBy: sort.sortBy,
        sortOrder: sort.sortOrder,
    }); }, [
        page,
        outcome,
        webhookType,
        isOfficeScoped,
        brokerId,
        brokerIdInput,
        integratorId,
        createdAtFrom,
        createdAtTo,
        sort,
    ]);
    React.useEffect(function () {
        var isCancelled = false;
        setIsFetching(true);
        setFetchError(undefined);
        integratorWebhookLogApi
            .getPaged(query)
            .then(function (result) {
            if (isCancelled) {
                return;
            }
            setLogs(result.items);
            setTotalPages(result.meta.totalPages);
        })
            .catch(function (error) {
            if (!isCancelled) {
                setFetchError(error);
            }
        })
            .finally(function () {
            if (!isCancelled) {
                setIsFetching(false);
            }
        });
        return function () {
            isCancelled = true;
        };
    }, [query, reloadCount]);
    // A changed filter starts again on the first page.
    var withFirstPage = function (setter) {
        return function (value) {
            setter(value);
            setPage(1);
        };
    };
    var handleResend = function (ids) { return __awaiter(void 0, void 0, void 0, function () {
        var results_1, counts, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsResending(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, integratorWebhookLogApi.resend({ ids: ids, brokerId: brokerId })];
                case 2:
                    results_1 = _a.sent();
                    setResendResults(function (previous) {
                        var next = __assign({}, previous);
                        results_1.forEach(function (result) {
                            next[result.id] = result;
                        });
                        return next;
                    });
                    onDeselectIds(ids);
                    counts = countResultsByStatus(results_1);
                    showAlert({
                        type: counts.OK === results_1.length ? "success" : "info",
                        message: getLocalizedText("integrator_webhook_log.resend.summary", {
                            ok: "".concat(counts.OK),
                            failed: "".concat(counts.FAILED),
                            skipped: "".concat(counts.SKIPPED),
                        }),
                    });
                    // Every attempt is written as a new row, so the list is out of date now.
                    setReloadCount(function (count) { return count + 1; });
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _a.sent();
                    showAlert({
                        type: "error",
                        message: getLocalizedText("integrator_webhook_log.resend.error"),
                        content: getMessageForError(error_1),
                        error: error_1,
                    });
                    return [3 /*break*/, 5];
                case 4:
                    setIsResending(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    // The selection, a row's menu and the detail all resend through the same confirm step.
    var requestResend = function (ids) {
        var isSingle = ids.length === 1;
        confirm({
            type: "warning",
            title: isSingle
                ? getLocalizedText("integrator_webhook_log.resend.confirm.title_single")
                : getLocalizedText("integrator_webhook_log.resend.confirm.title", {
                    value: "".concat(ids.length),
                }),
            info: getLocalizedText(isSingle
                ? "integrator_webhook_log.resend.confirm.info_single"
                : "integrator_webhook_log.resend.confirm.info"),
            primaryActions: [
                {
                    title: getLocalizedText("integrator_webhook_log.cta.resend"),
                    onPress: function () {
                        void handleResend(ids);
                    },
                },
            ],
        });
    };
    // Render
    var renderResendResult = function (log) {
        var result = resendResults[log.id];
        if (!result) {
            return log.resendOfId
                ? getLocalizedText("integrator_webhook_log.resend_of", {
                    id: "".concat(log.resendOfId),
                })
                : EMPTY_VALUE;
        }
        var reasonLabel = getReasonLabel(result.reason);
        return (_jsxs(Stack, { vertical: true, spacing: "extraTight", children: [_jsx(Lozenge, { appearance: getResendStatusAppearance(result.status), children: getLocalizedText("integrator_webhook_log.resend.status.".concat(result.status.toLowerCase())) }), reasonLabel && (_jsx(TextStyle, { variation: "subdued", size: "small", children: reasonLabel }))] }));
    };
    var columns = __spreadArray(__spreadArray([
        {
            heading: getLocalizedText("integrator_webhook_log.heading.date"),
            sortBy: EIntegratorWebhookLogSortBy.CreatedAt,
            render: function (log) {
                return log.createdAt ? formatDateAndTime(log.createdAt) : EMPTY_VALUE;
            },
        },
        {
            heading: getLocalizedText("integrator_webhook_log.heading.integrator"),
            sortBy: EIntegratorWebhookLogSortBy.Integrator,
            render: function (log) { var _a; return (_a = log.integratorName) !== null && _a !== void 0 ? _a : "#".concat(log.integratorId); },
        }
    ], (isOfficeScoped
        ? []
        : [
            {
                heading: getLocalizedText("integrator_webhook_log.heading.owner"),
                sortBy: EIntegratorWebhookLogSortBy.Owner,
                render: function (log) { var _a; return (_a = log.ownerName) !== null && _a !== void 0 ? _a : EMPTY_VALUE; },
            },
        ]), true), [
        {
            heading: getLocalizedText("integrator_webhook_log.heading.triggered_by"),
            sortBy: EIntegratorWebhookLogSortBy.TriggeredBy,
            render: function (log) {
                var _a;
                return (_a = log.createdByName) !== null && _a !== void 0 ? _a : getLocalizedText("integrator_webhook_log.triggered_by.automatic");
            },
        },
        {
            heading: getLocalizedText("integrator_webhook_log.heading.webhook_type"),
            sortBy: EIntegratorWebhookLogSortBy.WebhookType,
            render: function (log) { return getWebhookTypeLabel(log.effectiveWebhookType); },
        },
        {
            heading: getLocalizedText("integrator_webhook_log.heading.status_code"),
            sortBy: EIntegratorWebhookLogSortBy.ResponseStatus,
            render: function (log) { var _a; return (_a = log.responseStatus) !== null && _a !== void 0 ? _a : EMPTY_VALUE; },
        },
        {
            heading: getLocalizedText("integrator_webhook_log.heading.duration"),
            sortBy: EIntegratorWebhookLogSortBy.DurationMs,
            render: function (log) {
                return log.durationMs !== null
                    ? getLocalizedText("integrator_webhook_log.duration_ms", {
                        value: "".concat(log.durationMs),
                    })
                    : EMPTY_VALUE;
            },
        },
        {
            heading: getLocalizedText("integrator_webhook_log.heading.outcome"),
            sortBy: EIntegratorWebhookLogSortBy.Outcome,
            render: function (log) { return (_jsx(Lozenge, { appearance: getOutcomeAppearance(log.outcome), children: getLocalizedText("integrator_webhook_log.outcome.".concat(log.outcome.toLowerCase())) })); },
        },
        {
            // What this session's resend did, which the API does not store on the row.
            heading: getLocalizedText("integrator_webhook_log.heading.resend_result"),
            render: renderResendResult,
        },
    ], false);
    var headings = columns.map(function (column) { return column.heading; });
    var columnContentTypes = columns.map(function () { return "text"; });
    var sortColumnIndex = columns.findIndex(function (column) { return column.sortBy === sort.sortBy; });
    var handleSort = function (headingIndex, direction) {
        var _a;
        var nextSort = getSortAfterHeaderClick((_a = columns[headingIndex]) === null || _a === void 0 ? void 0 : _a.sortBy, direction);
        if (!nextSort) {
            return;
        }
        setSort(nextSort);
        setPage(1);
    };
    var rows = logs.map(function (log) {
        var blockedReason = getReasonLabel(log.resendBlockedReason);
        return {
            id: log.id,
            multiSelectDisabled: !!log.resendBlockedReason,
            multiSelectDisabledTooltip: blockedReason,
            content: columns.map(function (column) { return column.render(log); }),
            actions: [
                {
                    content: getLocalizedText("integrator_webhook_log.cta.details"),
                    onClick: function () { return setDetailLogId(log.id); },
                },
                {
                    // A row the API would refuse is not offered; its reason is on the checkbox tooltip
                    // and in the detail.
                    content: getLocalizedText("integrator_webhook_log.cta.resend"),
                    onClick: function () { return requestResend([log.id]); },
                    isDisabled: !!log.resendBlockedReason || isResending,
                },
            ],
        };
    });
    return (_jsxs(Stack, { vertical: true, spacing: "loose", children: [_jsxs(S.Filters, { children: [_jsx(S.SegmentedFilter, { children: _jsx(SegmentedControl, { name: "outcome", size: "small", selected: outcome, onChange: withFirstPage(setOutcome), options: [
                                {
                                    id: ALL,
                                    value: getLocalizedText("integrator_webhook_log.outcome.all"),
                                },
                                {
                                    id: EIntegratorWebhookLogOutcome.Succeeded,
                                    value: getLocalizedText("integrator_webhook_log.outcome.succeeded"),
                                },
                                {
                                    id: EIntegratorWebhookLogOutcome.Failed,
                                    value: getLocalizedText("integrator_webhook_log.outcome.failed"),
                                },
                            ] }) }), _jsx(S.SegmentedFilter, { children: _jsx(SegmentedControl, { name: "webhookType", size: "small", selected: webhookType, onChange: withFirstPage(setWebhookType), options: __spreadArray([
                                {
                                    id: ALL,
                                    value: getLocalizedText("integrator_webhook_log.webhook_type.all"),
                                }
                            ], Object.values(EIntegratorWebhookType).map(function (type) { return ({
                                id: type,
                                value: getWebhookTypeLabel(type),
                            }); }), true) }) })] }), _jsxs(S.Filters, { children: [!isOfficeScoped && (_jsx(S.FilterField, { children: _jsx(TextField, { name: "brokerId", type: "number", label: getLocalizedText("integrator_webhook_log.filter.broker_id"), value: brokerIdInput, onChange: function (event) {
                                return withFirstPage(setBrokerIdInput)(event.currentTarget.value);
                            } }) })), !isOfficeScoped && (_jsx(S.FilterField, { children: _jsx(Select, { id: "integratorId", name: "integratorId", label: getLocalizedText("integrator_webhook_log.heading.integrator"), value: integratorId, options: __spreadArray([
                                { value: ALL, label: getLocalizedText("system.all") }
                            ], Object.entries(EIntegratorIds).map(function (_a) {
                                var name = _a[0], id = _a[1];
                                return ({
                                    value: id,
                                    label: name,
                                });
                            }), true), onChange: function (_a) {
                                var value = _a.value;
                                return withFirstPage(setIntegratorId)(value);
                            } }) })), _jsx(S.FilterField, { children: _jsx(TextField, { name: "createdAtFrom", type: "date", label: getLocalizedText("integrator_webhook_log.filter.created_at_from"), value: createdAtFrom, onChange: function (event) {
                                return withFirstPage(setCreatedAtFrom)(event.currentTarget.value);
                            } }) }), _jsx(S.FilterField, { children: _jsx(TextField, { name: "createdAtTo", type: "date", label: getLocalizedText("integrator_webhook_log.filter.created_at_to"), value: createdAtTo, onChange: function (event) {
                                return withFirstPage(setCreatedAtTo)(event.currentTarget.value);
                            } }) })] }), selectedIds.length > 0 && (_jsxs(Stack, { alignment: "center", spacing: "tight", children: [_jsx(Button, { appearance: "primary", onClick: function () { return requestResend(__spreadArray([], selectedIds, true)); }, isSubmitting: isResending, isDisabled: isResending, children: "".concat(getLocalizedText("integrator_webhook_log.cta.resend"), " (").concat(selectedIds.length, ")") }), _jsx(Button, { appearance: "link", onClick: function () { return onDeselectIds(__spreadArray([], selectedIds, true)); }, isDisabled: isResending, children: getLocalizedText("system.clear_selection") })] })), fetchError ? (_jsx(Banner, { title: getMessageForError(fetchError), variation: "error", hasDismiss: false })) : null, !fetchError && !isFetching && logs.length === 0 ? (_jsx(EmptyState, { heading: getLocalizedText("integrator_webhook_log.empty"), icon: "logs" })) : null, logs.length > 0 && (_jsx(DataTable, { multiSelect: true, selectedIds: selectedIds, onSelectRow: function (id) { return onSelectId(Number(id)); }, onDeselectRow: function (id) { return onDeselectId(Number(id)); }, onSelectPage: function (ids) { return onSelectIds(ids.map(Number)); }, onDeselectPage: function (ids) { return onDeselectIds(ids.map(Number)); }, isLoadingData: isFetching, onRowClick: function (rowIndex) { var _a; return setDetailLogId((_a = logs[rowIndex]) === null || _a === void 0 ? void 0 : _a.id); }, hasFocusableRows: true, columnContentTypes: columnContentTypes, headings: headings, sortable: columns.map(function (column) { return !!column.sortBy; }), sortColumnIndex: sortColumnIndex, sortDirection: sort.sortOrder, onSort: handleSort, rows: rows })), totalPages > 1 && (_jsx(Pagination, { initialPage: page - 1, pageCount: totalPages, onPageChange: function (_a) {
                    var selected = _a.selected;
                    return setPage(selected + 1);
                } })), detailLogId !== undefined && (_jsx(IntegratorWebhookLogDetailModal, { logId: detailLogId, brokerId: brokerId, resendResult: resendResults[detailLogId], isResending: isResending, onResend: function () { return requestResend([detailLogId]); }, onClose: function () { return setDetailLogId(undefined); } }))] }));
};
